<template>
  <a-modal
    :title="title"
    width="50%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    :dialogStyle="{ top: '160px' }"
    wrapClassName="identity-pdf-modal"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="确认"
    cancel-text="取消"
    :destroyOnClose="true"
    :ok-button-props="{ htmlType: 'button' }"
  >
    <div>
      <div class="go-back" v-if="num != 1">
        <img
          @click="goBack"
          style="width: 30px; height: 30px; cursor: pointer"
          src="~@/assets/images/img59.png"
          alt
          title="返回"
        />
      </div>
      <div class="btn-list" v-if="num == 1">
        <div
          class="btn-item"
          @click="goGump(1)"
          :class="num == 1 ? 'btn-active' : ''"
        >
          <img src="@/assets/images/btn1.png" alt="" />
          <div>手动添加</div>
        </div>
        <div
          class="btn-item"
          @click="goGump(2)"
          :class="num == 2 ? 'btn-active' : ''"
        >
          <img src="@/assets/images/btn2.png" alt="" />
          <div>AI导入</div>
        </div>
        <div
          class="btn-item"
          @click="goGump(3)"
          :class="num == 3 ? 'btn-active' : ''"
        >
          <img src="@/assets/images/btn3.png" alt="" />
          <div>
            {{ $route.name != "szMicroClass" ? "模板导入" : "批量导入" }}
          </div>
        </div>
      </div>
      <div v-if="num == 2 && !isTemporaryStorage" class="ai-import-panel">
        <!-- :label-col="labelCol" :wrapper-col="wrapperCol" labelAlign="left" -->
        <a-form-model ref="ruleForm" :rules="rules" :model="form">
          <a-form-model-item
            label="文件上传"
            prop="fileName"
            class="ai-upload-item"
          >
            <a-upload
              class="ai-upload-dragger"
              type="drag"
              :file-list="fileList"
              :disabled="isEdit || loading"
              :remove="(file, fileList) => handleRemove(file, fileList)"
              :before-upload="(file, fileList) => beforeUpload(file, fileList)"
              accept=".pdf,.doc,.docx"
              :multiple="false"
            >
              <p class="ai-upload-icon">
                <a-icon :type="loading ? 'loading' : 'cloud-upload'" />
              </p>
              <p class="ai-upload-text">
                {{ loading ? "正在上传…" : "点击或将文件拖拽到此处上传" }}
              </p>
              <p class="ai-upload-hint">
                请上传申报书，支持 pdf、doc、docx 格式，一次仅可上传 1 个文件
              </p>
            </a-upload>
          </a-form-model-item>
          <!-- <a-form-model-item label="识别方式">
            <a-radio-group v-model="form.chatType" @change="onchange">
              <a-radio value="1">文件</a-radio>
              <a-radio value="2">文件内容</a-radio>
            </a-radio-group>
          </a-form-model-item> -->
        </a-form-model>
      </div>
      <div v-if="num == 3">
        <a-form-model :model="importForm" @submit.native.prevent>
          <a-form-model-item
            label="导入类型"
            style="margin-bottom: 0px; display: flex"
          >
            <a-radio-group v-model="importForm.chatType" @change="handleChange">
              <a-radio value="1">基本信息导入</a-radio>
              <a-radio value="2">全量导入</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <div @click="downmb" v-if="importForm.chatType == 1" class="downmb">
            下载基本信息导入模板
          </div>
          <div @click="downmb" v-else class="downmb">下载全量信息导入模板</div>
          <a-form-model-item
            label="文件上传"
            style="margin-bottom: 0px; display: flex"
          >
            <a-upload
              :before-upload="importBeforeUpload"
              :custom-request="noopUpload"
              :showUploadList="false"
              accept=".xls,.xlsx"
              :disabled="loadings"
            >
              <a-button :disabled="isEdit || loadings" :loading="loadings">
                <a-icon type="upload" />上传附件
              </a-button>
              <div class="text2">注：请上传相应模板xls,.xlsx格式的文件</div>
              <!-- <a-button style="margin-right: 20px" :loading="loadings" :disabled="loadings" type="primary">导入</a-button> -->
            </a-upload>
            <a
              :href="path + item.fileUrl"
              target="_blank"
              rel="noopener noreferrer"
              v-for="(item, index) in list"
              :key="index"
              v-if="list.length > 0"
              @click.stop
              >{{ item.fileName }}</a
            >
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </a-modal>
</template>

<script>
import {
  getAction,
  postAction,
  putAction,
  idenfileUpdate,
  lxApplyexportTemplate,
  lxApplyexportQlTemplate,
} from "@/api/index";
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      isTemporaryStorage: false, //是否存在暂存
      visible: false,
      confirmLoading: false,
      labelCol: { span: 2 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        // applyId:'',
        fileName: "",
        filePath: "",
        chatType: "1",
        // evidenceExplain:'',
        // type:'',
      },
      name: "",
      id: "",
      rules: {
        fileName: [
          {
            validator: (rule, value, callback) => {
              console.log(value, this.form.joinYear);
              if (this.form.fileName != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请上传材料"));
              }
            },
            required: true,
            message: "请上传材料",
            trigger: "change",
          },
        ],
        // evidenceExplain: [
        //   {
        //     required: true,
        //     message: "请输入佐证材料说明",
        //     trigger: "blur",
        //   },
        // ],
      },
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "手动添加",
      fileList: [],
      loading: false,
      num: 2,
      importForm: {
        chatType: "2",
        fileName: "",
        filePath: "",
      },
      loadings: false,
      list: [],
      path: baseURL,
      importLabelCol: { span: 2 },
    };
  },
  methods: {
    // 获取暂存
    getTemporaryStorage() {
      let applyType = 0;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      postAction("/lx/lxApply/getAiData?applyType=" + applyType).then((res) => {
        console.log(res);
        if (res.code == 200) {
          if (res.result) {
            // 有数据 则弹框提示是否使用暂存
            this.$confirm({
              title: `提示`,
              cancelText: "取消",
              okText: "确认",
              content:
                "检测到有未编辑完成的内容，是否使用,如果取消则删除暂存数据!",
              onOk: () => {
                this.isTemporaryStorage = true;
                this.goUploadPage({ new: "ai" }).catch(() => {
                  this.title = "AI导入";
                  this.isTemporaryStorage = false;
                });
              },
              onCancel: () => {
                postAction(
                  "/lx/lxApply/removeAiData?applyType=" + applyType
                ).then((res) => {
                  console.log(res);
                  this.title = "AI导入";
                  this.isTemporaryStorage = false;
                });
              },
            });
          } else {
            this.title = "AI导入";
            this.isTemporaryStorage = false;
          }
        }
      });
    },
    onchange(event) {
      this.form.chatType = event.target.value;
      this.$forceUpdate();
    },
    handleChange(event) {
      this.importForm.chatType = event.target.value;
      this.importForm.fileName = "";
      this.importForm.filePath = "";
      this.$forceUpdate();
    },
    handleRemove(file, fileList) {
      // console.log(file,"1111");
      //   this.fileList = this.fileList.filter(item => {
      //     if (item.path.indexOf(file.name) === -1) {
      //       return item;
      //     }
      //   });
      //   const index = this.fileList.indexOf(file);
      //   const newFileList = this.fileList.slice();
      //   newFileList.splice(index, 1);
      this.form.fileName = "";
      this.form.filePath = "";
      this.fileList = [];
    },
    beforeUpload(file, fileList) {
      this.handleUpload(file);
      return false;
    },
    handleUpload(file) {
      if (this.fileList.length >= 1) {
        this.$message.error("一次只能上传一个文件,请移除后再上传");
        return;
      }
      const name = (file && file.name) || "";
      const ext = name.includes(".")
        ? name.slice(name.lastIndexOf(".")).toLowerCase()
        : "";
      if (![".pdf", ".doc", ".docx"].includes(ext)) {
        this.$message.error("仅支持上传 pdf、doc、docx 格式的申报书");
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      idenfileUpdate(formData).then((res) => {
        if (res.code === 200) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.result.filePath;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          fileItem.status = "done";
          this.fileList.push(fileItem);
          this.form.fileName = file.name;
          this.form.filePath = res.result.filePath;
          this.id = res.result.id;
          this.$refs.ruleForm.clearValidate("fileName");
          this.loading = false;
        } else {
          this.$message.error(res.message || "上传失败");
          this.loading = false;
        }
      });
    },
    init(type, record) {
      this.type = type;
      this.visible = true;
      this.name = record.name;
      if (type == "add") {
        this.form = {};
        this.importForm = {};
        this.importForm.chatType = "2";
        this.num = 1;
        // this.form.applyId=record.id;
        // this.form.type=record.type;
        this.form.fileName = "";
        this.form.filePath = "";
        this.form.chatType = "1";
        this.fileList = [];
        this.title = "手动添加";
      } else {
        // this.title = "编辑材料";
        // // console.log(record);
        //  this.form = {
        //  	  applyId:record.applyId,
        //     fileName: record.fileName,
        //     filePath:record.filePath,
        //     evidenceExplain:record.evidenceExplain,
        //     type:record.type,
        //     id:record.id,
        //  };
        //   if (
        //   record &&
        //   record.fileName != "" &&
        //   record.fileName != null &&
        //   record.filePath != "" &&
        //   record.filePath != null
        // ) {
        //   this.fileList = [];
        //   let fileItem = {};
        //   fileItem.path = record.filePath;
        //   fileItem.name =  record.fileName;
        //   fileItem.uid = 1;
        //   this.fileList.push(fileItem);
        // }
      }
    },
    handleCancel() {
      this.visible = false;
    },
    submit() {
      if (this.num == "2") {
        this.$refs.ruleForm.validate((valid) => {
          // console.log(valid);
          if (valid) {
            if (this.type == "add") {
              sessionStorage.setItem("gzs1", "");
              sessionStorage.setItem("pp1", "");
              this.goUploadPage({
                new: "ai",
                id: this.id,
                fileName: this.form.fileName,
                filePath: this.form.filePath,
                chatType: this.form.chatType,
              });
              this.visible = false;
              // postAction("/lxbase/lxApplyEvidence/add", params).then((res) => {
              //   if (res.code == 200) {
              //     this.visible = false;
              //     this.$message.success("添加成功");
              //     this.$emit("addEvidence");
              //   } else {
              //     this.$message.error(res.message);
              //   }
              // });
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else if (this.num == 3) {
        this.visible = false;
        this.$emit("importsuccess");
      }
    },
    goGump(num) {
      this.num = num;
      if (num != 1) {
        if (num == 2) {
          this.getTemporaryStorage();
        } else {
          this.title = "模板导入";
        }
        return;
      }
      this.goUploadPage({ new: "new" });
    },
    getUploadRoute() {
      const name = this.$route.name;
      if (name === "szStudio") {
        return { routeName: "szStudioDataUpload", applyType: 1 };
      }
      if (name === "educationalBrand") {
        return { routeName: "educationalBrandDataUpload", applyType: 2 };
      }
      if (name === "szMicroClass") {
        return { routeName: "szMicroClassDataUpload", applyType: 3 };
      }
      return null;
    },
    goUploadPage(query) {
      const route = this.getUploadRoute();
      if (!route) {
        return Promise.reject(new Error("unknown upload route"));
      }
      return this.$router.push({
        name: route.routeName,
        query: {
          applyType: route.applyType,
          ...query,
        },
      });
    },
    noopUpload() {},
    importBeforeUpload(file) {
      const formData = new FormData();
      formData.append("file", file);
      let url = "";
      if (this.importForm.chatType == "1") {
        if (this.$route.name === "szStudio") {
          url = "/lxBase/szStudioImport?applyType=1";
        } else if (this.$route.name === "educationalBrand") {
          url = "/lxBase/tsBrandStudioImport?applyType=2";
        } else {
          url = "/lxBase/wkImport?applyType=3";
        }
      } else {
        if (this.$route.name === "szStudio") {
          url = "/lxBase/combinedImport?applyType=1";
        } else if (this.$route.name === "educationalBrand") {
          url = "/lxBase/combinedImport?applyType=2";
        } else {
          url = "/lxBase/combinedImport?applyType=3";
        }
      }
      this.loadings = true;
      postAction(url, formData).then((res) => {
        if (res.code === 200) {
          // console.log("111111");
          this.$message.success("导入成功");
          let that = this;
          that.importForm.fileName = "1111";
          that.importForm.filePath = "222";
          setTimeout(function () {
            that.loadings = false;
            that.visible = false;
            that.$emit("importsuccess");
            that.list = [];
          }, 2000);
        } else {
          this.$message.warning(res.message);
          if (res.code == "201") {
            this.list = [];
            this.list.push({
              fileName: res.result.fileName,
              fileUrl: res.result.fileUrl,
            });
          }
          this.loadings = false;
        }
      });
      return false;
    },
    downmb() {
      let applyType = 1;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      if (this.importForm.chatType == "1") {
        lxApplyexportTemplate({ applyType: applyType }).then((res) => {
          let url = window.URL.createObjectURL(
            new Blob([res], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          let fileName = "";
          if (this.$route.name === "szStudio") {
            fileName = "思政工作室基本信息";
          } else if (this.$route.name === "educationalBrand") {
            fileName = "特色文化育人品牌基本信息";
          } else {
            fileName = "思政微课基本信息";
          }
          link.setAttribute("download", `${fileName}导入模板` + ".xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url);
        });
      } else {
        lxApplyexportQlTemplate({ applyType: applyType }).then((res) => {
          let url = window.URL.createObjectURL(
            new Blob([res], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          let fileName = "";
          if (this.$route.name === "szStudio") {
            fileName = "思政工作室全量信息";
          } else if (this.$route.name === "educationalBrand") {
            fileName = "特色文化育人品牌全量信息";
          } else {
            fileName = "思政微课全量信息";
          }
          link.setAttribute("download", `${fileName}导入模板` + ".xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url);
        });
      }
    },
    goBack() {
      this.num = 1;
      this.title = "手动添加";
      this.importForm.fileName = "";
      this.importForm.filePath = "";
      this.form.fileName = "";
      this.form.filePath = "";
      this.list = [];
      this.fileList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.go-back {
  width: 100%;
  text-align: right;

  img {
    margin-right: 20px;
  }
}

.btn-list {
  width: 66%;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;

  .btn-item {
    width: 154px;
    height: 178px;
    background: #f7f7ff;
    box-shadow: 0px 0 7px 0 #9ab5ff;
    border-radius: 6px 6px 6px 6px;
    border: 1px solid #ffffff;
    text-align: center;
    padding: 12px 14px;
    box-sizing: border-box;
    cursor: pointer;
    font-size: 20px;
    color: #333333;
  }

  .btn-item:hover,
  .btn-active {
    border: 1px solid #5f8aff;
  }
}

/deep/ .ant-upload {
  margin-top: 5px;
}

.text2 {
  margin-top: 10px;
}

.ai-import-panel {
  padding: 8px 4px 4px;
}

.ai-upload-item {
  margin-bottom: 0;

  /deep/ .ant-form-item-label {
    line-height: 1.4;
    margin-bottom: 10px;
  }

  /deep/ .ant-form-item-control-wrapper {
    width: 100%;
  }
}

.ai-upload-dragger {
  display: block;
  width: 100%;

  /deep/ .ant-upload.ant-upload-drag {
    width: 100%;
    min-height: 180px;
    padding: 28px 20px;
    background: #f7f9fc;
    border: 1px dashed #b8c7e0;
    border-radius: 10px;
    transition: border-color 0.2s ease, background-color 0.2s ease;
  }

  /deep/ .ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover,
  /deep/ .ant-upload.ant-upload-drag-hover:not(.ant-upload-disabled) {
    border-color: #3b82f6;
    background: #f0f6ff;
  }

  /deep/ .ant-upload-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 124px;
  }

  /deep/ .ant-upload-list {
    margin-top: 12px;
    text-align: left;
  }
}

.ai-upload-icon {
  margin: 0 0 10px;
  font-size: 42px;
  color: #3b82f6;
  line-height: 1;
}

.ai-upload-text {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
}

.ai-upload-hint {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
  line-height: 1.6;
}

.downmb {
  line-height: 40px;
  cursor: pointer;
  color: #0f5ef1cc;
  /*margin-bottom:20px;*/
  display: inline-block;
}

/deep/ .ant-modal-title {
  text-align: center;
}

/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>

<style lang="scss">
/* 弹层挂到 body，需非 scoped；相对默认 top:100px 下移 */
.identity-pdf-modal {
  .ant-modal {
    top: 160px;
    padding-bottom: 24px;
  }
}
</style>
